import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import StatusBadge from "@/components/StatusBadge";
import { toast } from "sonner";

export default function TechnicianAssignment() {
  const [list, setList] = useState([]);
  const [techs, setTechs] = useState([]);
  const [picks, setPicks] = useState({});

  const load = async () => {
    const { data } = await api.get("/complaints", { params: { status: "New Complaint" } });
    setList(data);
  };
  useEffect(() => {
    load();
    api.get("/technicians").then((r) => setTechs(r.data));
  }, []);

  const assign = async (cid) => {
    const tid = picks[cid];
    if (!tid) return;
    try { await api.post(`/complaints/${cid}/assign-technician`, { technician_id: tid }); toast.success("Assigned"); load(); }
    catch (e) { toast.error("Failed", { description: formatApiErrorDetail(e.response?.data?.detail) }); }
  };

  return (
    <div className="space-y-5" data-testid="assignment-page">
      <div>
        <h1 className="font-heading text-3xl font-bold text-slate-900">Technician Assignment</h1>
        <p className="text-sm text-slate-500 mt-1">Unassigned new complaints. Pick a technician based on province / area / category.</p>
      </div>
      <Card><CardContent className="p-0">
        <div className="overflow-x-auto">
          <table className="w-full dense-table">
            <thead className="bg-slate-50 border-b"><tr>
              <th className="text-left text-xs uppercase tracking-wide text-slate-600 font-semibold">Complaint #</th>
              <th className="text-left text-xs uppercase tracking-wide text-slate-600 font-semibold">Customer</th>
              <th className="text-left text-xs uppercase tracking-wide text-slate-600 font-semibold">Brand / Product</th>
              <th className="text-left text-xs uppercase tracking-wide text-slate-600 font-semibold">Province / Area</th>
              <th className="text-left text-xs uppercase tracking-wide text-slate-600 font-semibold">Status</th>
              <th className="text-left text-xs uppercase tracking-wide text-slate-600 font-semibold">Assign Technician</th>
              <th></th>
            </tr></thead>
            <tbody>
              {list.length === 0 && <tr><td colSpan={7} className="text-center py-12 text-slate-400">No unassigned complaints.</td></tr>}
              {list.map((c) => {
                const matched = techs
                  .filter((t) => t.active)
                  .map((t) => {
                    let score = 0;
                    if (t.province && c.province === t.province) score += 3;
                    if (t.area && c.district_area === t.area) score += 2;
                    return { ...t, score };
                  })
                  .sort((a, b) => b.score - a.score);
                return (
                  <tr key={c.id} data-testid={`assign-row-${c.complaint_number}`}>
                    <td><Link className="font-mono font-medium hover:underline" to={`/complaints/${c.id}`}>{c.complaint_number}</Link></td>
                    <td>{c.customer_name}<div className="text-xs text-slate-500">{c.phone_number_1}</div></td>
                    <td>{c.brand}<div className="text-xs text-slate-500">{c.product_name}</div></td>
                    <td>{c.province}<div className="text-xs text-slate-500">{c.district_area}</div></td>
                    <td><StatusBadge status={c.status} /></td>
                    <td>
                      <Select value={picks[c.id] || ""} onValueChange={(v) => setPicks({ ...picks, [c.id]: v })}>
                        <SelectTrigger className="w-64 h-8" data-testid={`pick-tech-${c.id}`}><SelectValue placeholder="Suggest..." /></SelectTrigger>
                        <SelectContent>
                          {matched.map((t) => (
                            <SelectItem key={t.id} value={t.id}>
                              {t.name} {t.score > 0 && <span className="text-xs text-emerald-700 ml-1">(match {t.score})</span>}
                            </SelectItem>
                          ))}
                        </SelectContent>
                      </Select>
                    </td>
                    <td><Button size="sm" onClick={() => assign(c.id)} disabled={!picks[c.id]} className="bg-slate-900 text-white" data-testid={`assign-btn-${c.id}`}>Assign</Button></td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </CardContent></Card>
    </div>
  );
}
